import { SxProps, Theme } from '@mui/material';
import { Nullable } from '@/types';

export function mergeSX(...sx: Nullable<SxProps<Theme>>[]) {
  return sx.flatMap((item) => (Array.isArray(item) ? item : [item]));
}
